import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import React from "react";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import Snackbar from '../../Snacbar'
import FundReportService from "../../../Services/Reports/FundReportService";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
  height: "100%",
}));

function FundRefund() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };

  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [exportExcelProcs, setexportExcelProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [loading, setloading] = useState(false)
  const [FilteredDetails, setFilteredDetails] = useState([])
  const [fndrefundValues, setfndrefundValues] = useState({
    from: getDate(),
    to: getDate(),
    status: '-1',
  });
  const fromhandlechange = (e) => {
    setfndrefundValues({ ...fndrefundValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setfndrefundValues({ ...fndrefundValues, to: e.target.value })
  };
  const statushandlechange = (e) => {
    setfndrefundValues({ ...fndrefundValues, status: e.target.value })
    console.log('details==>' + JSON.stringify(e.target.value))

  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  //getfunctions
  const getFundStatus = () => {
    FundReportService.getFundStatus().then(res => {
      setdetails1(res.data);
    })
  }
  // buttonsOperation
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    setdetails2([])
    setFilteredDetails([])
    let details = { fromDate: fndrefundValues.from, toDate: fndrefundValues.to, status: fndrefundValues.status }
    console.log('details==>' + JSON.stringify(details))
    FundReportService.getFundRefundReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else
        setdetails2(res.data);
      setFilteredDetails(res.data)
      setshowProcs(false)
      setloading(false)
    })
  }
  const exportBtnClick = () => {
    setexportExcelProcs(true)
    if (details2[0] === [] || !details2[0]) {
      setMessage('No Record Found');
      setseverit('warning')
      setOpen(true)
      setexportExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details2.length; i++) {
        if (details2[i].consignmentNumber !== '') {
          tableContent += details2[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details2[i].vendorName !== '') {
          tableContent += details2[i].vendorName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].clientName !== '') {
          tableContent += details2[i].clientName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqPurpose !== '') {
          tableContent += details2[i].reqPurpose + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqAmount !== '') {
          tableContent += details2[i].reqAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].refundAmt !== '') {
          tableContent += details2[i].refundAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].refundMode !== '') {
          tableContent += details2[i].refundMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].refundDate !== '') {
          tableContent += details2[i].refundDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].refundName !== '') {
          tableContent += details2[i].refundName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].refundRemarks !== '') {
          tableContent += details2[i].refundRemarks + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      let details = {
        headerName: "3,0,FUND REFUND REPORT", headerDetails: "1,1,FROM DATE : " + fndrefundValues.from + "/4,1,TO DATE : " + fndrefundValues.to,
        tableHeader: "0,3,Sl.No/1,3,Job No/2,3,Vendor Name/3,3,Client Name/4,3,Description/5,3,Request Amount/6,3,Refund Amount/7,3,Refund Mode/8,3,Refund Date/9,3,Refund Name/10,3,Refund Remarks",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "FundRefund", totalNumberOfColumn: 11, tableContent: contenall.substring(0, contenall.length - 1)
      }
      FundReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

        setexportExcelProcs(false)
      })
    }
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getFundStatus();
  }, []);

  //table search
  const jobNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const vendorNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { vendorNmOnchange(e.target.value) }} />

  }
  const refundMdSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { refundMdOnchange(e.target.value) }} />
  }
  const refundBySrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { refundByOnchange(e.target.value) }} />
  }
  //
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const vendorNmOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.vendorName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const refundMdOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.refundMode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const refundByOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.refundName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <div>
      <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>FUND REFUND REPORT</center></div>
            <Row>
              <Col></Col>
              <Col></Col>
              <Col>
                <label style={mystyle1}>FromDate</label>
              </Col>
              <Col>
                <Form.Control size="sm" type="date" style={mystyle} value={fndrefundValues.from} onChange={fromhandlechange} />
              </Col>
              <Col>
                <label style={mystyle1}>ToDate</label>
              </Col>
              <Col>
                <Form.Control size="sm" type="date" style={mystyle} value={fndrefundValues.to} onChange={tohandlechange} />
              </Col>
              <Col>
                <label style={mystyle1}>FundStatus</label>
              </Col>
              <Col>
                <Form.Select size="sm" style={mystyle} value={fndrefundValues.status} onChange={statushandlechange}>
                  <option value={'-1'}>ALL</option>
                  {details1.map(trns => (
                    <option value={trns.requestStatus}>{trns.requestStatus}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <br></br>
            <Row className="mb-1">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="primary"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={showBtnClick}>{showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button variant="success"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={exportBtnClick}>{exportExcelProcs ? 'processing...' : 'Export Excel'}</Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            {" "}
            <ItemPap1>
              {" "}
              <TableContainer sx={{ height: 360 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>JobNo{jobNmSrch()}</StyledTableCell>
                      <StyledTableCell>VendorName{vendorNmSrch()}</StyledTableCell>
                      <StyledTableCell>ClientName</StyledTableCell>
                      <StyledTableCell>Description</StyledTableCell>
                      <StyledTableCell>RequestAmount</StyledTableCell>
                      <StyledTableCell>RefundAmount</StyledTableCell>
                      <StyledTableCell>RefundMode{refundMdSrch()}</StyledTableCell>
                      <StyledTableCell>RefundDate</StyledTableCell>
                      <StyledTableCell>RefundBy{refundBySrch()}</StyledTableCell>
                      <StyledTableCell>RefundRemark</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.vendorName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clientName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqPurpose}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.refundAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.refundMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.refundDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.refundName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.refundRemarks}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default FundRefund;
